import { NOTIFICATIONS_ACTIONS } from "./actions-enum";
import { NOTIFICATIONS_MUTATIONS } from "./mutations-enum";
import { NotificationStorage } from "@/helpers/NotificationStorage";

export default {
    async [NOTIFICATIONS_ACTIONS.LOAD_NOTIFICATIONS]({ commit }, userId) {
        if (!userId) return;
        try {
            const notifications = await NotificationStorage.getByUser(userId);
            commit(NOTIFICATIONS_MUTATIONS.SET_NOTIFICATIONS, notifications);
        } catch (e) {
            //console.error("Errore caricamento notifiche:", e);
        }
    },
    [NOTIFICATIONS_ACTIONS.PUSH_NOTIFICATION]({ commit }, notification) {
        commit(NOTIFICATIONS_MUTATIONS.ADD_NOTIFICATION, notification);
    },
    [NOTIFICATIONS_ACTIONS.MARK_ALL_AS_READ]({ commit }) {
        commit(NOTIFICATIONS_MUTATIONS.MARK_ALL_AS_READ);
    },
    [NOTIFICATIONS_ACTIONS.MARK_SINGLE_AS_READ]({ commit }, notification) {
        commit(NOTIFICATIONS_MUTATIONS.MARK_SINGLE_AS_READ, notification.id);
    },
    async [NOTIFICATIONS_ACTIONS.REMOVE_NOTIFICATIONS_BY_TYPE]({ commit, rootGetters }, type) {
        const profile = rootGetters['auth/profile'];
        if (profile && profile.id_utente_concorsando) {
            try {
                await NotificationStorage.removeByType(profile.id_utente_concorsando, type);
                commit(NOTIFICATIONS_MUTATIONS.REMOVE_NOTIFICATIONS_BY_TYPE, type);
            } catch (e) {
                // console.error("Errore rimozione notifiche per tipo:", e);
            }
        }
    }
};